import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATION,
  UPDATE_NOTIFICATION,
  CREATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  GET_NOTIFICATIONS_REQUEST_PENDING,
  GET_NOTIFICATIONS_REQUEST_SUCCESS,
  GET_NOTIFICATIONS_REQUEST_ERROR,
  CHANGE_NOTIFICATIONS_REQUEST_PENDING,
  CHANGE_NOTIFICATIONS_REQUEST_SUCCESS,
  CHANGE_NOTIFICATIONS_REQUEST_ERROR,
} from '../types/notifications'

const initialState = {
  items: [],
  item: {},
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS:
      return { ...state, items: action.payload }
    case GET_NOTIFICATION:
      return { ...state, item: action.payload }
    case UPDATE_NOTIFICATION:
      const itemIndex = state.items.findIndex((item) => item.id === action.payload.id)
      const newItems = [...state.items]
      newItems[itemIndex] = { ...action.payload }
      return { ...state, items: newItems }
    case CREATE_NOTIFICATION:
      return { ...state, items: [...state.items, action.payload] }
    case DELETE_NOTIFICATION:
      return { ...state, items: state.items.filter((item) => item.id !== action.payload) }
    case GET_NOTIFICATIONS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    case GET_NOTIFICATIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    case GET_NOTIFICATIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    case CHANGE_NOTIFICATIONS_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }
    case CHANGE_NOTIFICATIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }
    case CHANGE_NOTIFICATIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }
    default:
      return state
  }
}

export default notifications
